import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { BaseSelect } from '@msc-b2c/shared-components';
import { MulticruiseSelectionI } from '@msc-b2c/interfaces/types';
import { useDispatch } from 'react-redux';
import {
  clearCart,
  createNewSession,
  getActiveSession,
  resetMyCruiseData,
  setActiveCruiseId,
} from '@msc-b2c/shared-utils';

export const MulticruiseSelection = ({
  defaultValue,
  multicruise,
  multiCruisePlaceholder,
}: Readonly<MulticruiseSelectionI>) => {
  const dispatch = useDispatch();
  const {
    formState: { errors },
    getValues,
    clearErrors,
    control,
  } = useForm();

  const handleCruiseChange = () => {
    // Handle the cruise change logic here
    const session = getActiveSession();
    const selectedCruiseId = getValues('selectedCruiseId');
    createNewSession(
      session.token,
      session.loginMode,
      'mymsc',
      session.email,
      session.name,
      session.surname,
      session.bookingNumber,
      selectedCruiseId,
      session.crmId,
      session.goldenId,
      session.passengerId
    );
    dispatch(resetMyCruiseData());
    dispatch(setActiveCruiseId(selectedCruiseId || null));
    dispatch(clearCart());
  };

  return (
    <Controller
      name={'selectedCruiseId'}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <BaseSelect
          label={multiCruisePlaceholder}
          placeholder={multiCruisePlaceholder}
          ariaLabel={multiCruisePlaceholder}
          items={multicruise.cruises}
          errors={errors}
          value={String(field.value ?? '')}
          fieldName={field.name}
          onChange={(value) => {
            field.onChange(value);
            handleCruiseChange();
          }}
          clearErrors={clearErrors}
        />
      )}
    />
  );
};
